import { Typography } from "@octopus-energy/coral/atoms"
import { CoralMapPopup } from "@octopus-energy/coral/maps"
import { IconSolarPanel, IconWindTurbine } from "@octopus-energy/icons"
import { useTranslations } from "next-intl"
import { type ProducerLocationFeature } from "../types"

type ProducersMapPopupProps = {
    data: ProducerLocationFeature
    setData: (data: ProducerLocationFeature | undefined) => void
}

export function ProducersMapPopup({ data, setData }: ProducersMapPopupProps) {
    const t = useTranslations("ProducersMapPopup")

    return (
        <CoralMapPopup
            key={data.properties.name}
            feature={data}
            offset={16}
            onClose={() => setData(undefined)}
        >
            {data.properties.technology === "SOLAR" ? (
                <IconSolarPanel size={35} />
            ) : (
                <IconWindTurbine size={35} />
            )}
            <Typography textStyle="h5">{data.properties.name}</Typography>
            <Typography textStyle="body2">
                {data.properties.type === "partner" ? t("label.partners") : t("label.octopus")}
            </Typography>
            <Typography textStyle="body2">
                Type: {data.properties.technology === "SOLAR" ? t("type.solar") : t("type.wind")}
            </Typography>
            {data.properties.avg_no_of_homes_powered && (
                <Typography textStyle="body2">
                    {t("averageHomesPowered", { count: data.properties.avg_no_of_homes_powered })}
                </Typography>
            )}
        </CoralMapPopup>
    )
}

ProducersMapPopup.messages = ["ProducersMapPopup"] as const
